import {
  ButtonActionType,
  ButtonSizeOptions,
  ButtonTypes,
  Constants,
  NestedWorkflowWidgetConfiguration,
  WidgetNames,
  WorkflowWidgetConfigurationAttributes,
} from '@finxone-platform/shared/sys-config-types';
import { FormSubmissionButtonWidgetBuilder, QuickLinkWidgetBuilder } from '../../example-builder';

export const editBeneficaryNestedWidgets = {
  submitButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Save Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Save Changes',
        globalStyling: true,
        globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
      },
    },
  },
};

export const editBeneficaryIntlNestedWidgets = {
  previousButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Previous Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Previous',
        globalStyling: true,
        globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        backGroundColor: 'var(--palette-color-2)',
        color: 'var(--color-on-background)',
        borderWidth: 1,
        borderColor: 'var(--color-border-color)',
        borderStyle: 'solid',
        verticalAlignment: 'center',
        marginRight: 10,
        marginTop: 15,
      },
    },
  },

  nextButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Next Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Next',
        globalStyling: true,
        globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        backGroundColor: 'var(--palette-color-2)',
        color: 'var(--color-on-background)',
        borderWidth: 1,
        borderColor: 'var(--color-border-color)',
        borderStyle: 'solid',
        verticalAlignment: 'center',
        marginTop: 15,
        marginLeft: 10,
      },
    },
  },
};

export const addBeneFasterPaymentNestedWidgets = {
  submitButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Submit Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Proceed',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
      },
    },
  },
};

export const intlBeneAddressNestedWidgets = {
  reviewDetailsButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Review Details Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Review Beneficiary Details',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
      },
    },
  },
};

export const addBeneficiaryNestedWidget = {
  submitButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Submit Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Proceed',
        globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
        globalStyling: true,
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
      },
    },
  },
};

export const createNestedQuickLinkWidgetConfig = (): NestedWorkflowWidgetConfiguration => {
  const config = new QuickLinkWidgetBuilder()
    .role()
    .attributes({
      widgetProperties: {
        isNestedWidget: true, // this is to identify that this quick link widget is used as a nested widget and not as a standalone widget in the page
        showButtonStyleContent: true,
        textContent: 'Quick Link',
      } as WorkflowWidgetConfigurationAttributes['widgetProperties'],
    } as WorkflowWidgetConfigurationAttributes)
    .configDisplayName('Quick Link')
    .setGlobalStylingClass(true, `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`)
    .build();

  // Ensure the returned object has the required properties for NestedWorkflowWidgetConfiguration
  return {
    name: config.name as WidgetNames,
    widgetConfigDisplayName: config.widgetConfiguration.widgetConfigDisplayName as string,
    attributes: config.widgetConfiguration.attributes,
    isRemovable: config.widgetConfiguration.isRemovable,
  };
};

export const createNestedActionButtonWidgetConfig = (): NestedWorkflowWidgetConfiguration => {
  const config = new FormSubmissionButtonWidgetBuilder()
    .configDisplayName('Action Button')
    .isRemovable(true)
    .attributes({
      widgetProperties: {
        isNestedWidget: true, // this is to identify that this quick link widget is used as a nested widget and not as a standalone widget in the page
        showButtonStyleContent: true,
        textContent: 'Action Button',
        buttonActionType: ButtonActionType.EDIT_BENEFICIARY,
      } as WorkflowWidgetConfigurationAttributes['widgetProperties'],
    } as WorkflowWidgetConfigurationAttributes)
    .setGlobalStylingClass(true, `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`)
    .build();

  // Ensure the returned object has the required properties for NestedWorkflowWidgetConfiguration
  return {
    name: config.name as WidgetNames,
    widgetConfigDisplayName: config.widgetConfiguration.widgetConfigDisplayName,
    attributes: config.widgetConfiguration.attributes,
    isRemovable: config.widgetConfiguration.isRemovable,
  };
};
